/**
 * Determines whether a date lands on midnight (12:00 a.m.) in the given timezone.
 *
 * Events without a start time are stored as midnight, so this is how we detect a
 * "blank" time that should not be displayed.
 *
 * @param date - The date to inspect
 * @param timezone - The timezone the date is displayed in (e.g., "America/Denver")
 * @returns true when the date renders as 00:00 in the timezone
 */
const isMidnightInTimeZone = (date: Date, timezone: string = 'UTC'): boolean => {
  if (isNaN(date.getTime())) {
    return false;
  }

  const parts = new Intl.DateTimeFormat('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone: timezone,
  }).formatToParts(date);

  const hour = parts.find((part) => part.type === 'hour')?.value;
  const minute = parts.find((part) => part.type === 'minute')?.value;

  return hour === '00' && minute === '00';
};

export default isMidnightInTimeZone;
